"use strict";

var MONTH_DAY_COUNT_31 = 31;
var MONTH_DAY_COUNT_30 = 30;
var MONTH_DAY_COUNT_29 = 29;
var MONTH_DAYS = {
  1: MONTH_DAY_COUNT_31,
  2: MONTH_DAY_COUNT_29,
  3: MONTH_DAY_COUNT_31,
  4: MONTH_DAY_COUNT_30,
  5: MONTH_DAY_COUNT_31,
  6: MONTH_DAY_COUNT_30,
  7: MONTH_DAY_COUNT_31,
  8: MONTH_DAY_COUNT_31,
  9: MONTH_DAY_COUNT_30,
  10: MONTH_DAY_COUNT_31,
  11: MONTH_DAY_COUNT_30,
  12: MONTH_DAY_COUNT_31
};
var isNumber = function isNumber(input) {
  return !Number.isNaN(Number.parseInt(input, 10));
};
var isValidMonth = function isValidMonth(input) {
  if (!isNumber(input)) {
    return false;
  }
  var parsedMonth = parseInt(input, 10);
  return parsedMonth > 0 && parsedMonth < 13;
};
var isValidDay = function isValidDay(day, month) {
  var monthParsed = Number.parseInt(month, 10);
  var dayParsed = Number.parseInt(day, 10);
  if (MONTH_DAYS[monthParsed] && Number.parseInt(dayParsed, 10) > 0 && Number.parseInt(dayParsed, 10) <= MONTH_DAYS[monthParsed]) {
    return true;
  }
  return false;
};
var splitDateProps = function splitDateProps(input) {
  return {
    month: input.substring(0, 2),
    day: input.substring(2, 4),
    year: input.substring(4)
  };
};
var isValidMMDD = function isValidMMDD(input) {
  if (!isNumber(input)) {
    return false;
  }
  var dateProps = splitDateProps(input);
  var month = dateProps.month;
  var day = dateProps.day;
  return isValidMonth(month) && isValidDay(day, month);
};
var formatMMDD = function formatMMDD(input, divider) {
  var dateProps = splitDateProps(input);
  return "".concat(dateProps.month).concat(divider).concat(dateProps.day).concat(divider);
};
var formatMMDDYYYY = function formatMMDDYYYY(input, divider) {
  var monthDayFormat = formatMMDD(input, divider);
  var year = input.substring(4);
  return "".concat(monthDayFormat).concat(year);
};
var validateLeapYear = function validateLeapYear(dateProps) {
  // if the year is not a leap year then February can't have 29 days
  var year = Number.parseInt(dateProps.year, 10);
  var month = Number.parseInt(dateProps.month, 10);
  var day = Number.parseInt(dateProps.day, 10);
  if (year % 4 !== 0 && month === 2 && day > 28) {
    return false;
  }
  return true;
};
var isValidYear = function isValidYear(input) {
  if (!isNumber(input)) {
    return false;
  }
  var dateProps = splitDateProps(input);
  var month = dateProps.month;
  var day = dateProps.day;
  return isValidMonth(month) && isValidDay(day, month) && validateLeapYear(dateProps);
};
module.exports = {
  MONTH_DAYS: MONTH_DAYS,
  isValidMonth: isValidMonth,
  isValidMMDD: isValidMMDD,
  isValidYear: isValidYear,
  isValidDay: isValidDay,
  formatMMDD: formatMMDD,
  formatMMDDYYYY: formatMMDDYYYY
};
